/* eslint-disable no-unused-vars */
import React from 'react';
import style from './detection.module.scss';
import { getDetection } from './getDetection';
import { LinearProgress } from '@mui/material';
import WarningIcon from 'icons/warning';
import { getDeclension } from 'utils/utils';

export const getHeaderTexts = (itemsInGroup: number) => {
  return itemsInGroup > 1
    ? {
        lightText: 'Укажите теги,',
        boldText: 'общие для выбранных элементов',
      }
    : {
        lightText: 'Укажите теги',
        boldText: 'для выбранного материала',
      };
};

const getTexts = (commonTags: number, itemsInGroup: number) => {
  const addedText = getDeclension(commonTags, [
    'Добавлен',
    'Добавлено',
    'Добавлено',
  ]);

  return itemsInGroup > 1
    ? {
        added: `${addedText} ${commonTags} ${getDeclension(commonTags, [
          'общий тег',
          'общих тега',
          'общих тегов',
        ])}`,
      }
    : {
        added: `${addedText} ${commonTags} ${getDeclension(commonTags, [
          'тег',
          'тега',
          'тегов',
        ])}`,
      };
};

export function Detection({
  commonTags,
  itemsInGroup,
}: {
  commonTags: number;
  itemsInGroup: number;
}) {
  const detection = getDetection(commonTags);
  const texts = getTexts(commonTags, itemsInGroup);

  return (
    <div className={style.container}>
      {itemsInGroup === 1 ? (
        <div className={style.line}>
          <LinearProgress
            variant="determinate"
            value={detection?.percent}
            color={detection?.color}
          />
        </div>
      ) : (
        ''
      )}

      <div className={style.details}>
        <WarningIcon className={style.icon}></WarningIcon>
        <b>
          <span>{texts.added}</span>
        </b>
      </div>
      {itemsInGroup === 1 ? (
        <div className={style.verdict}>
          <span>Возможность обнаружения:</span>
          <span style={{ color: `var(--${detection?.color})` }}>
            &nbsp;{detection?.text}
          </span>
        </div>
      ) : (
        ''
      )}
      <span className={style.instruction}>
        Добавьте минимум 3 тега. Так пользователи быстрее смогут найти ваш
        медиафайл
      </span>
    </div>
  );
}
